'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _reactFacebookLogin = require('react-facebook-login');

var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _reactIntl = require('react-intl');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _session = require('redux/modules/session');

var sessionActions = _interopRequireWildcard(_session);

var _info = require('redux/modules/info');

var _wishlist = require('redux/modules/wishlist');

var _push = require('redux/modules/push');

var _WeiboButton = require('components/ProviderButtons/WeiboButton');

var _WeiboButton2 = _interopRequireDefault(_WeiboButton);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _validation = require('utils/validation');

var _helpers = require('utils/helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Login: {
    displayName: 'Login'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/Login.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import MobileConnectButton from 'components/MobileConnectButton/MobileConnectButton';


var Login = _wrapComponent('Login')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user,
    isLoggedIn: state.session.isLoggedIn,
    loggingIn: state.session.loggingIn,
    callback: state.session.loginSignupCallback,
    sessionData: state.session.data,
    withPromo: state.session.withPromo,
    oldPromo: state.session.oldPromo,
    settingSessionData: state.session.settingSessionData,
    loadingSessionData: state.session.loadingSessionData,
    promoInput: state.session.promoInput,
    messages: state.language.messages,
    enabledLogins: state.info.siteConfigs.enabledLogins,
    locale: state.language.locale,
    mobileRedirectLogin: state.info.siteConfigs.mobileRedirectLogin,
    desktopRedirectLogin: state.info.siteConfigs.desktopRedirectLogin
  };
}, (0, _extends3.default)({}, sessionActions, { loadUserConfig: _info.loadUserConfig, loadWishlists: _wishlist.loadWishlists, requestPermission: _push.requestPermission })), _dec2 = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      switch: false,
      showPassword: false,
      // errorEmail: false,
      // errorPassword: false,
      errorMessage: '',
      emailError: false,
      emailErrorTemplateId: '',
      emailErrorTemplateValues: {},
      passwordError: false,
      passwordErrorTemplateId: '',
      passwordErrorTemplateValues: {}
    }, _this.onChangePromo = function (e) {
      // this.setState({promo: e.target.value});
      _this.props.setPromoInput(e.target.value);
      var value = e.target.value;
      setTimeout(function () {
        return _this.checkPromo(value);
      }, 1000);
    }, _this.checkPromo = function (promo) {
      if (promo === _this.props.promoInput) {
        _this.props.setSessionData({ promo: promo }).then(function () {
          _this.props.loadSessionData();
        });
      }
    }, _this.facebookCallback = function (response) {
      if (!response.accessToken) return;
      _this.props.facebookLogin(response.accessToken).then(_this.loggedIn);
    }, _this.googleCallback = function (response) {
      _this.props.googleLogin(response.getAuthResponse().id_token).then(_this.loggedIn);
    }, _this.mobileConnectCallback = function (response) {
      _this.props.mobileConnectLogin(response).then(_this.loggedIn);
    }, _this.weiboCallback = function (response) {
      if (response.error) {
        _this.setState({
          errorMessage: response.error_description
        });
        return;
      }
      _this.props.weiboLogin(response).then(_this.loggedIn);
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.validateForm()) {
        _this.props.login({
          email: _this.refs.loginEmail.value,
          password: _this.refs.loginPassword.value
        }).then(_this.loggedIn).catch(function (result) {
          _this.setState({ errorMessage: result.message });
        });
      }
    }, _this.openForgot = function () {
      _this.props.openForgot();
    }, _this.validateForm = function () {
      var email = _this.refs.loginEmail.value;
      var password = _this.refs.loginPassword.value;
      var data = {
        email: {
          value: email,
          required: true,
          format: 'email',
          label: _this.props.messages['login.email.placeholder']
        }, password: {
          value: password,
          required: true,
          label: _this.props.messages['login.password.placeholder']
        }
      };
      var validatedData = (0, _validation.validateForm)(data);
      (0, _keys2.default)(validatedData).map(function (field) {
        if (field === 'formError') return;
        _this.setState((0, _defineProperty3.default)({}, field + 'Error', validatedData[field].error));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateId', validatedData[field].templateId));
        _this.setState((0, _defineProperty3.default)({}, field + 'ErrorTemplateValues', validatedData[field].templateValues));
      });
      if (validatedData.formError) {
        return false;
      }
      return true;
    }, _this.loggedIn = function (result) {
      // this.refs.loginEmail.value = '';
      // this.refs.loginPassword.value = '';
      _this.props.loadUserConfig();
      _this.props.loadWishlists();
      // this.setState({
      //   errorEmail: false,
      //   errorPassword: false,
      //   errorMessage: '',
      // });
      if (_this.props.callback) {
        _this.props.callback();
      }
      if (result.isLoggedIn) {
        _this.props.loggedIn(result.user._id);
        _this.props.requestPermission();
      }
    }, _this.togglePassword = function () {
      return _this.setState({ showPassword: !_this.state.showPassword });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          emailError = _state.emailError,
          emailErrorTemplateId = _state.emailErrorTemplateId,
          emailErrorTemplateValues = _state.emailErrorTemplateValues,
          passwordError = _state.passwordError,
          passwordErrorTemplateId = _state.passwordErrorTemplateId,
          passwordErrorTemplateValues = _state.passwordErrorTemplateValues,
          errorMessage = _state.errorMessage;
      // const {loggingIn} = this.props;

      var _props = this.props,
          messages = _props.messages,
          loggingIn = _props.loggingIn,
          sessionData = _props.sessionData,
          withPromo = _props.withPromo,
          settingSessionData = _props.settingSessionData,
          loadingSessionData = _props.loadingSessionData,
          oldPromo = _props.oldPromo,
          discount = _props.discount,
          enabledLogins = _props.enabledLogins,
          locale = _props.locale,
          emailUsed = _props.emailUsed;

      var promoLoaderImage = require('theme/images/ajax-loader.gif');
      var enableRedirectLogin = (0, _helpers.isMobile)() ? this.props.mobileRedirectLogin : this.props.desktopRedirectLogin;
      return _react3.default.createElement(
        'div',
        { className: 'login', styleName: 'main-container' },
        emailUsed ? _react3.default.createElement(
          'h3',
          null,
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'login.email_used', values: { email: _react3.default.createElement(
                'span',
                { className: _LoginSignup2.default.bold },
                '"',
                emailUsed,
                '"'
              ) } })
        ) : _react3.default.createElement(
          'h2',
          { styleName: 'header' },
          _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'login.header' }),
          oldPromo && sessionData && sessionData.redeem && (0, _keys2.default)(sessionData.redeem).length > 0 && _react3.default.createElement(
            'span',
            null,
            ' & Get',
            ' ',
            sessionData.redeem.percentage > 0 ? sessionData.redeem.percentage * 100 + '% OFF' : sessionData.redeem.constant + ' ' + (sessionData.redeem.currency || 'THB')
          ),
          withPromo && discount && _react3.default.createElement(
            'span',
            null,
            ' & Get',
            ' ',
            discount.startsWith('p') ? discount.slice(1) + '% OFF' : discount.slice(1) + ' THB'
          )
        ),
        this.props.subTitle && _react3.default.createElement(
          'h3',
          null,
          this.props.subTitle
        ),
        oldPromo && sessionData && sessionData.redeem && sessionData.redeem.code && !this.props.omitCode && _react3.default.createElement(
          'h3',
          null,
          'PROMO: ',
          _react3.default.createElement(
            'span',
            { styleName: 'orange-text' },
            sessionData.redeem.code
          )
        ),
        withPromo && !this.props.omitCode && _react3.default.createElement(
          'div',
          { styleName: 'promo-form' },
          _react3.default.createElement(
            'div',
            { styleName: 'promo-container' },
            _react3.default.createElement(
              'label',
              { styleName: 'promo-label' },
              'Promo'
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'promo-input-container' },
              _react3.default.createElement('input', { styleName: 'custom-input', placeholder: messages['login.insert_promo_here'], onChange: this.onChangePromo, defaultValue: this.props.promoInput }),
              (settingSessionData || loadingSessionData) && _react3.default.createElement('img', { src: promoLoaderImage, width: '24', height: '24', styleName: 'promo-loader', alt: 'promo loader' })
            )
          ),
          sessionData.redeem && (0, _keys2.default)(sessionData.redeem).length > 0 && _react3.default.createElement(
            'p',
            { styleName: 'promo-text' },
            _react3.default.createElement('i', { styleName: 'green-check' }),
            ' Get',
            ' ',
            sessionData.redeem.percentage > 0 ? sessionData.redeem.percentage * 100 + '% OFF' : sessionData.redeem.constant + ' ' + (sessionData.redeem.currency || 'THB')
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'buttons' },
          enabledLogins.indexOf('facebook') >= 0 && !enableRedirectLogin && _react3.default.createElement(_reactFacebookLogin2.default, {
            cssClass: _LoginSignup2.default['btn-facebook'],
            appId: _config2.default.facebookAppId,
            callback: this.facebookCallback,
            textButton: messages['login.facebook'],
            scope: 'public_profile, email' }),
          enabledLogins.indexOf('facebook') >= 0 && enableRedirectLogin && _react3.default.createElement(
            'a',
            { className: _LoginSignup2.default['btn-facebook'], href: 'https://www.facebook.com/v2.10/dialog/oauth?client_id=' + _config2.default.facebookAppId + '&redirect_uri=' + _config2.default.baseURL.en + '/api/session/login/oauth/facebook&state=' + btoa('site:' + window.location.href + ',redirect_uri:' + _config2.default.baseURL.en + '/api/session/login/oauth/facebook') },
            messages['login.facebook']
          ),
          enabledLogins.indexOf('google') >= 0 && !enableRedirectLogin && _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_reactGoogleLogin2.default, {
              className: _LoginSignup2.default['btn-google'],
              clientId: _config2.default.googleClientId,
              buttonText: messages['login.google'],
              onSuccess: this.googleCallback,
              onFailure: function onFailure() {}
            })
          ),
          enabledLogins.indexOf('google') >= 0 && enableRedirectLogin && _react3.default.createElement(
            'a',
            { className: _LoginSignup2.default['btn-google'], href: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + _config2.default.googleClientId + '&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile&redirect_uri=' + _config2.default.baseURL.en + '/api/session/login/oauth/google&state=' + btoa('site:' + window.location.href + ',redirect_uri:' + _config2.default.baseURL.en + '/api/session/login/oauth/google') },
            messages['login.google']
          ),
          enabledLogins.indexOf('weibo') >= 0 && _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_WeiboButton2.default, {
              className: _LoginSignup2.default['btn-weibo'],
              locale: locale,
              callback: this.weiboCallback
            })
          )
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'or-flex' },
          _react3.default.createElement('span', { styleName: 'line' }),
          _react3.default.createElement(
            'span',
            { styleName: 'or' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'signup.or' })
          ),
          _react3.default.createElement('span', { styleName: 'line' })
        ),
        _react3.default.createElement(
          'form',
          { styleName: 'form', onSubmit: this.handleSubmit },
          _react3.default.createElement(
            'div',
            { styleName: 'input-container' },
            _react3.default.createElement('input', { className: 'login-email', styleName: emailError ? 'custom-input-error' : 'custom-input', placeholder: messages['login.email.placeholder'], type: 'email', ref: 'loginEmail', defaultValue: emailUsed }),
            emailError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: emailErrorTemplateId, values: emailErrorTemplateValues })
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'input-container' },
            _react3.default.createElement('input', { className: 'login-password', styleName: passwordError ? 'custom-input-error' : 'custom-input', placeholder: messages['login.password.placeholder'], type: this.state.showPassword ? 'text' : 'password', ref: 'loginPassword' }),
            passwordError && _react3.default.createElement(
              'p',
              { styleName: 'error' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: passwordErrorTemplateId, values: passwordErrorTemplateValues })
            ),
            _react3.default.createElement(
              'p',
              { styleName: 'show-password' },
              _react3.default.createElement(
                'a',
                { onClick: this.togglePassword },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: this.state.showPassword ? 'login.password.hide' : 'login.password.show' })
              )
            )
          ),
          errorMessage && _react3.default.createElement(
            'p',
            { styleName: 'error' },
            errorMessage
          ),
          _react3.default.createElement(
            'button',
            { className: 'login-button', type: 'submit', styleName: 'btn-action' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'login.header' })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'forgot-container' },
            _react3.default.createElement(
              'a',
              { styleName: 'forgot-password', onClick: this.openForgot },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'login.forgot' })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: loggingIn ? 'loader-container' : 'loader-container-hide' },
          _react3.default.createElement(_Loader2.default, null)
        )
      );
    }
  }]);
  return Login;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  login: _react2.PropTypes.func,
  logout: _react2.PropTypes.func,
  facebookLogin: _react2.PropTypes.func,
  googleLogin: _react2.PropTypes.func,
  mobileConnectLogin: _react2.PropTypes.func,
  weiboLogin: _react2.PropTypes.func,
  callback: _react2.PropTypes.func,
  paymentForm: _react2.PropTypes.bool,
  sendReset: _react2.PropTypes.func,
  openForgot: _react2.PropTypes.func,
  openLogin: _react2.PropTypes.func,
  isLoggedIn: _react2.PropTypes.bool,
  loggedIn: _react2.PropTypes.func,
  loadUserConfig: _react2.PropTypes.func,
  loggingIn: _react2.PropTypes.bool,
  loadWishlists: _react2.PropTypes.func,
  switch: _react2.PropTypes.bool,
  sessionData: _react2.PropTypes.object,
  withPromo: _react2.PropTypes.bool,
  oldPromo: _react2.PropTypes.bool,
  settingSessionData: _react2.PropTypes.bool,
  loadingSessionData: _react2.PropTypes.bool,
  emailUsed: _react2.PropTypes.string,
  discount: _react2.PropTypes.string,
  promoInput: _react2.PropTypes.string,
  setSessionData: _react2.PropTypes.func,
  loadSessionData: _react2.PropTypes.func,
  setPromoInput: _react2.PropTypes.func,
  messages: _react2.PropTypes.object,
  enabledLogins: _react2.PropTypes.array,
  locale: _react2.PropTypes.string,
  requestPermission: _react2.PropTypes.func,
  mobileRedirectLogin: _react2.PropTypes.bool,
  desktopRedirectLogin: _react2.PropTypes.bool,
  subTitle: _react2.PropTypes.string,
  omitCode: _react2.PropTypes.bool
}, _class2.defaultProps = {
  paymentForm: false
}, _temp2)) || _class) || _class));

exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/Login.js
// module id = 462
// module chunks = 47